import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import { LocationAttendanceResponse } from "../model/EmployeeShiftRecord";
import { LocationAttendanceRequest } from "../request/LocationAttendanceRequest";
import { HttpClientError } from "../../../../providers/HttpClient";

const LocationAttendanceApiService = async (
  request: LocationAttendanceRequest
): Promise<LocationAttendanceResponse> => {
  try {
    const { data } = await axios.get(
      `/shift-locations/${request.locationId}/attendance/`,
      {
        params: {
          ...(request.date && { date: request.date }),
          ...(request.date_from && { date_from: request.date_from }),
          ...(request.date_to && { date_to: request.date_to }),
        },
      }
    );
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    const errorMessage = HttpClientError(axiosError);
    const customError = new Error(errorMessage);

    customError.cause = axiosError;
    throw customError;
  }
};

const useLocationAttendanceApiService = (
  request: LocationAttendanceRequest
): UseQueryResult<LocationAttendanceResponse, Error | AxiosError> => {
  const { enabled = true, refetchInterval = false, ...queryParams } = request;
  return useQuery<LocationAttendanceResponse, Error | AxiosError>(
    [
      "LocationAttendanceApiService",
      queryParams.locationId ?? null,
      queryParams.date ?? null,
      queryParams.date_from ?? null,
      queryParams.date_to ?? null,
    ],
    () => LocationAttendanceApiService(queryParams),
    {
      keepPreviousData: true,
      enabled: enabled && !!queryParams.locationId,
      // Poll only when the caller opts in (today views). react-query's default
      // refetchIntervalInBackground:false pauses polling when the tab is hidden.
      refetchInterval,
    }
  );
};

export { LocationAttendanceApiService, useLocationAttendanceApiService };
